import { useState, useEffect } from 'react';
import { collection, query, orderBy, onSnapshot, addDoc, updateDoc, doc, deleteDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { CallPanel } from '../types';
import { toast } from 'react-hot-toast';

export function useCallPanel() {
  const [calls, setCalls] = useState<CallPanel[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, 'callPanel'), orderBy('calledAt', 'desc'));
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const callsData = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      })) as CallPanel[];
      
      setCalls(callsData);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const addCall = async (callData: Omit<CallPanel, 'id'>) => {
    try {
      await addDoc(collection(db, 'callPanel'), callData);
      toast.success('Chamada adicionada à fila!');
    } catch (error) {
      console.error('Erro ao adicionar chamada:', error);
      toast.error('Erro ao adicionar chamada');
      throw error;
    }
  };

  const updateCallStatus = async (id: string, status: CallPanel['status']) => {
    try {
      await updateDoc(doc(db, 'callPanel', id), { status });
    } catch (error) {
      console.error('Erro ao atualizar status da chamada:', error);
      toast.error('Erro ao atualizar status da chamada');
      throw error;
    }
  };

  const deleteCall = async (id: string) => {
    try {
      await deleteDoc(doc(db, 'callPanel', id));
      toast.success('Chamada removida da fila!');
    } catch (error) {
      console.error('Erro ao remover chamada:', error);
      toast.error('Erro ao remover chamada');
      throw error;
    }
  };

  return {
    calls,
    loading,
    addCall,
    updateCallStatus,
    deleteCall
  };
}